export const idToStrongId = (id: string) => {
  const isStrongId = !id.includes(":")
  return isStrongId ? id : id.split(":").slice(-1)[0]
}

type NonOptionalString<T> = T extends string ? T : never

export const buildId = <T extends { __typename?: string }>(
  modelName: NonOptionalString<T["__typename"]>,
  id: string | undefined,
) => {
  if (!id) return null
  return `${modelName}:${idToStrongId(id)}` as const
}
